import {useSearchParams, useNavigate} from 'react-router-dom';
import {useState, useEffect} from 'react';

import ClientViewDragRegion from '../components/dragRegion';
import AuthTwoFactorMain from "./components/main";
import AuthTwoFactorFooter from "./components/footer";

import AuthTwoFactorLoading from "../components/loading"

function AuthTwoFactorPage() {
    const navigate = useNavigate();
    const [isReady, setIsReady] = useState(false)
    const [isClient, setIsClient] = useState(false);

    const [showAlertOK, setShowAlertOK] = useState(false)
    const [OKAlertText, setOKAlertText] = useState("")
    const [showAlertERROR, setShowAlertERROR] = useState(false)
    const [ERRORAlertText, setERRORAlertText] = useState("")

    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const showAlert = (type, text) => {
        if (type === "ok") {
            setOKAlertText(text)
            setShowAlertOK(true)

            setTimeout(function() {
                setShowAlertOK(false)
            }, 3500)
        } else {
            setERRORAlertText(text)
            setShowAlertERROR(true)

            setTimeout(function() {
                setShowAlertERROR(false)
            }, 3500)
        }

    }

    const handleCheckOTP = async (otp_code) => {
        const response = await fetch('/api/check-otp', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({token: token, otp: otp_code}),
        });

        const data = await response.json();
        console.log(data)

        if (response.ok) {
            await window.pywebview.api.save_token_from_web(data);
            showAlert("ok", "Logged in, redirecting")

            setTimeout(function() {
                navigate("/client-view")
            }, 2500)
        } else {
            showAlert("error", "Code not valid, retry")
        }
    };

    const resendOTP = async () => {
        const response = await fetch('/api/resend-otp', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({token: token, otp: "-1"}),
        });

        const data = await response.json();
        console.log(data)

        if (response.ok) {
            showAlert("ok", "We've sent another mail to your account")
        } else {
            showAlert("error", "Error while sending your code: Page expired")
        }
    };

    useEffect(() => {
        if (token !== null && token !== undefined && token !== "") {
            setIsReady(true)
        }
    }, [token])

    useEffect(() => {
        if (window.pywebview && window.pywebview.api && window.pywebview.api.resize_window) {
            window.pywebview.api.resize_window(1200, 1000);
            setIsClient(true)
        }
    })

    if (!isClient) {
        return (
            <div className="relative flex justify-center items-center min-h-screen w-full flex-col overflow-x-hidden">
                <p>You can view this page only via client windows software</p>
            </div>
        )
    }

    if (!isReady) {
        return <AuthTwoFactorLoading />
    }

    return (
        <>
        <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden">
            <ClientViewDragRegion/>
            <AuthTwoFactorMain handleCheckOTP={handleCheckOTP} resendOTP={resendOTP}/>
            <AuthTwoFactorFooter/>
        </div>

        {showAlertOK && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-green text-sm right-[10px] top-[10px] select-none animate-[show-alert_3s_ease-in-out_forwards]">{OKAlertText}</span>}
        {showAlertERROR && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-red text-sm right-[10px] top-[10px] select-none animate-[show-alert_3s_ease-in-out_forwards]">{ERRORAlertText}</span>}
        </>
    );
}


export default AuthTwoFactorPage;